/* Opciones de compra de una localidad (Evento -> Localidades y asientos -> Opciones de compra): el precio normal
   es "Individual" y cada modalidad activa (fila de precios: modalidades [{ codigo, nombre, precio, factor }]) es
   otra opcion sobre las MISMAS sillas. La opcion elegida reemplaza precio y factor en la localidad que se pasa al
   modal de sillas y al carrito; asi el cobro por paquete, la validacion de pares y modalidad_codigo funcionan solos. */

export const opcionesDe = (precio) => (Array.isArray(precio?.modalidades) ? precio.modalidades.filter((m) => Number(m?.precio) > 0) : [])

// Localidad con la opcion aplicada (opcion null = Individual: precio normal de la localidad)
export const aplicarOpcion = (precio, opcion) => {
    if (!opcion) return { ...precio, modalidad_elegida: "INDIVIDUAL", modalidad_codigo: "", modalidad_nombre: "Individual" }
    const valor = String(opcion.precio)
    const factor = Math.max(1, Math.floor(Number(opcion.factor) || 1))
    return {
        ...precio,
        precio_normal: valor, precio_tarjeta: valor, precio_descuento: valor, precio_discapacidad: valor,
        factor_boletos: factor, correlativo_factor_boletos: factor,
        modalidad_codigo: opcion.codigo, modalidad_nombre: opcion.nombre, modalidad_elegida: opcion.codigo,
        precio_individual: precio.precio_normal,
    }
}

// Texto de una opcion para el selector
export const textoOpcion = (precio, opcion) => {
    if (!opcion) return `Individual · $${Number(precio?.precio_normal || 0).toFixed(2)} c/u`
    const factor = Math.max(1, Math.floor(Number(opcion.factor) || 1))
    return `${opcion.nombre} · $${Number(opcion.precio).toFixed(2)}${factor > 1 ? ` por ${factor}` : ""}`
}

/* Si ya hay algo de esa localidad en el carrito, se sigue con la misma opcion (no se mezclan en una compra).
   carrito: getVerTienda(). Devuelve la localidad con la opcion del carrito, o null si no hay nada. */
export const opcionDelCarrito = (precio, carrito) => {
    const item = (carrito || []).find((t) => t && t.localidad === precio?.localidad && t.localidaEspacio?.modalidad_elegida)
    if (!item) return null
    const elegida = item.localidaEspacio.modalidad_elegida
    if (elegida === "INDIVIDUAL") return aplicarOpcion(precio, null)
    const opcion = opcionesDe(precio).find((m) => m.codigo === elegida)
    return opcion ? aplicarOpcion(precio, opcion) : null
}
